/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-3/5">
        <vx-card>
          <h1 class="font-light">Your Tickets</h1>
          <div class="vx-row mt-6">
            <div class="vx-col w-1/5">
              <h3 class="font-bold">Ticket ID</h3>
            </div>
            <div class="vx-col w-2/5">
              <h3 class="font-bold">Subject</h3>
            </div>
            <div class="vx-col w-1/5">
              <h3 class="font-bold">Date</h3>
            </div>
            <div class="vx-col w-1/5">
              <h3 class="font-bold">Priority</h3>
            </div>
          </div>
          <div
            class="vx-row mt-3 border-solid rounded m-1 p-2 cursor-pointer"
            :class="currentTab === 0 ? 'border-success' : 'border-white'"
            @click="currentTab = 0"
          >
            <div class="vx-col p-0 w-1/5">
              <h3 class="font-bold">#8675309</h3>
            </div>
            <div class="vx-col p-0 w-2/5 truncate">
              <h3 class="font-light">
                Michael is reporting that the Internet Kiosk machine is intermittently freezing and has lagged performance
              </h3>
            </div>
            <div class="vx-col w-1/5">
              <h3 class="font-bold">1/16/2020</h3>
            </div>
            <div class="vx-col p-0 w-1/5">
              <h3 class="bg-danger-gradient text-center font-bold rounded">HIGH</h3>
            </div>
          </div>
        </vx-card>
        <vx-card class="mt-4">
          <h1 class="font-light">Assets</h1>
          <div class="mt-5">
            <vs-table data="[]">
              <template slot="thead">
                <vs-th>PC</vs-th>
                <vs-th>PC002</vs-th>
              </template>
              <template>
                <vs-tr>
                  <vs-td>User</vs-td>
                  <vs-td>Michael</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>CPU Use</vs-td>
                  <vs-td>24%</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Drive</vs-td>
                  <vs-td>68GB of 121GB free</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Memory</vs-td>
                  <vs-td>4096 of 4096 used</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Asset Tag</vs-td>
                  <vs-td>P2R0H11</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-2/5">
        <vx-card v-if="currentTab === 0">
          <div class="flex items-center">
            <h2 class="font-bold">Ticket Details: <span class="font-light">#8675309</span></h2>
          </div>
          <div class="flex items-center mt-4">
            <h2 class="font-bold">Status: <span class="font-light">Opened</span></h2>
          </div>
          <div class="flex items-center mt-4">
            <h2 class="font-bold">Priority: <span class="font-light text-danger">High</span></h2>
          </div>
          <div class="flex items-center mt-4">
            <h2 class="font-bold">Category: <span class="font-light">Technical Bug Reports</span></h2>
          </div>
          <div class="flex items-center mt-4">
            <h2 class="font-bold">
              Assigned To: <span class="font-light">{{ activeUserInfo.username }}</span>
            </h2>
          </div>
          <div class="flex items-center mt-4">
            <h2 class="font-bold">Assigned Date: <span class="font-light">1/16/2020</span></h2>
          </div>
          <div class="w-full rounded mt-4 mb-4" style="height: 4px; background: #ffffff"></div>
          <div class="flex items-center">
            <h2 class="font-bold">
              Subject:
              <span class="font-light"
                >Michael is reporting that the Internet Kiosk machine is intermittently freezing and has lagged performance</span
              >
            </h2>
          </div>
          <div class="mt-4">
            <h2 class="font-bold">Attachments: <span class="font-light">None</span></h2>
          </div>
          <div class="flex items-center justify-between mt-4">
            <h2 class="font-bold mr-2">Issue:</h2>
            <v-select
              placeholder="Select an option from the dropdown"
              class="w-3/4 ml-2"
              :options="issueOptions"
              v-model="selectedIssue"
              clas
            />
          </div>
          <div class="mt-1">
            <small v-if="selectedIssueCorrect !== null && selectedIssueCorrect === false" class="text-danger font-semibold"
              >This answer is invalid</small
            >
            <small v-if="selectedIssueCorrect !== null && selectedIssueCorrect === true" class="text-success font-semibold"
              >This answer is correct</small
            >
          </div>

          <div class="flex items-center justify-between mt-4">
            <h2 class="font-bold">Asset Affected:</h2>
            <v-select
              placeholder="Select an option from the dropdown"
              class="w-3/4 ml-2"
              :options="causedBy"
              v-model="selectedCausedBy"
              clas
            />
          </div>
          <div class="mt-1">
            <small v-if="selectedCausedByCorrect !== null && selectedCausedByCorrect === false" class="text-danger font-semibold"
              >This answer is invalid</small
            >
            <small v-if="selectedCausedByCorrect !== null && selectedCausedByCorrect === true" class="text-success font-semibold"
              >This answer is correct</small
            >
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      currentTab: 0,

      issueOptions: [
        'High Memory Utilization',
        'Bad Windows Install',
        'No Active Drivers',
        'Bad Ethernet Connection',
        'No Memory Installed',
        'Windows Not Updated',
        'Malware Detected',
        'BSOD',
        'Boot Loop',
        'No Disk Space',
      ],
      causedBy: ['PC001', 'PC002', 'PC003', 'PC004'],

      selectedIssue: null,
      selectedIssueCorrect: null,

      selectedCausedBy: null,
      selectedCausedByCorrect: null,
    };
  },
  methods: {
    popupImage(url) {
      window.open(
        url,
        'popUpWindow',
        'height=600,width=850,left=150,top=150,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,directories=no, status=no',
      );
    },
    markSimulation() {
      let totalScore = 0;

      if (this.selectedIssue === 'High Memory Utilization') {
        totalScore++;
        this.selectedIssueCorrect = true;
      } else {
        this.selectedIssueCorrect = false;
      }

      if (this.selectedCausedBy === 'PC002') {
        totalScore++;
        this.selectedCausedByCorrect = true;
      } else {
        this.selectedCausedByCorrect = false;
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
    changePage(val) {
      if (val === 'next') {
        this.currentPage++;
      }
      if (val === 'previous') {
        this.currentPage--;
      }
    },
  },
  mounted() {},
  components: {
    Prism,
    vSelect,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
